module.exports = __webpack_public_path__ + "img/db8b347.jpg";